import { buildFormData } from "./payload.helper";

const unitsHelper = {
  forCreate: ({ name, district_id, no_of_staff, status, monitoring_officer_id }) =>
    buildFormData({ name, district_id, no_of_staff, status, monitoring_officer_id }),
  forUpdate: (id, { name, district_id, no_of_staff,status, monitoring_officer_id }) => ({
    id,
    body: buildFormData({ name, district_id, no_of_staff , status, monitoring_officer_id }),
  }),
};

export default unitsHelper;
